export class DockGroupCardModel {
  dockGroupId: string = undefined;
  dockLessonCardId: string = undefined;
  dockLessonCardTitle: string = undefined;
  dockLessonCardDecorationColor: string = undefined;
  isCustomCard: boolean = undefined;
  topicKey: string = undefined;
  sanitizedTitle: string = undefined;
}
